/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable padding-line-between-statements */
import { Icon } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useTranslator } from '@jutro/locale';
import { ErrorLevel } from '@xengage/gw-portals-edge-validation-js';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import classNames from 'classnames';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import _ from 'lodash';
import React, { useContext } from 'react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import BuildingLocationUtil from "twia-capability-quoteandbind-cp-react/util/BuildingLocationUtil.js";
import StandardAddressValidationUtil from 'twia-capability-address-component/util/StandardAddressValidationUtil';
import styles from './TWIAWizardSideMenu.module.scss';
import wizardMessages from '../../common/TWIAWizardMessages.messages.js';


/**
 * @typedef {import('@xengage/gw-portals-edge-validation-js/errors').GenericUIIssue} GenericUIIssue
 */

/**
 * Renders an icon for steps with errors
 * @param {Array<GenericUIIssue>} errorsAndWarnings array
 * @returns {Object}
 */
function renderErrors(errorsAndWarnings = []) {
    const highestLevel = errorsAndWarnings
        .map(err => err.level)
        .reduce((currentHighest, currentError) => {
            if (!currentHighest) {
                return currentError;
            }

            if (currentHighest === ErrorLevel.LEVEL_WARN) {
                // currentError can only Greater or Equal than currentHighest
                return currentError;
            }

            return currentHighest;
        }, null);

    switch (highestLevel) {
        case ErrorLevel.LEVEL_ERROR:
            return (
                <Icon
                    icon="mi-remove_circle_outline"
                    className={styles.errorIssue}
                />
            );
        case ErrorLevel.LEVEL_WARN:
            return <Icon icon="mi-warning" className={styles.warningIssue} />;
        default:
            return null;
    }
}

async function jumpRenderModal(
    index,
    wizardContext,
    steps,
    authHeader,
    currentStepIndex,
    isFnolWizard
) {
    // DE15783
    const modalMessages = {
        TWIAWizard: {
            title: wizardMessages.TWIAWizardModalTitle,
            message: wizardMessages.TWIAWizardModalMessage,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
            cancelButtonText: wizardMessages.wizardSideMenuModalCancel,
            className: styles.jut__Button__filled,
        }, // DE15912
        TWIAResidentialWizard: {
            title: wizardMessages.TWIAWizardModalTitle,
            message: wizardMessages.TWIAWizardModalMessage,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
            cancelButtonText: wizardMessages.TWIAWizardModalCancel,
            className: styles.jut__Button__filled,
        },
        CancelModal: {
            title: wizardMessages.TWIAWizardModalCancelAddBuildTitle,
            message: wizardMessages.TWIAWizardModalCancelAddBuildDescription,
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
            cancelButtonText: wizardMessages.TWIAWizardModalCancel,
            className: styles.jut__Button__filled,
        }
    };

    const { showConfirm, jumpTo, wizardData, wizardSnapshot, onPageJump } = wizardContext;
    if (isFnolWizard) {
        const fnolModalMsgs = {
            ...modalMessages.TWIAWizard,
            messageProps: {
                ok: commonMessages.yes,
                close: commonMessages.close,
            },
        };

        const result = await showConfirm(fnolModalMsgs);

        if (result === 'confirm') {
            jumpTo(index)
        }
    } else {
        const editMode = wizardData.isAddBuilding;
        const buildingsAndLocationsStep = steps.find(step => step.id === 'BuildingsAndLocationsPage');

        // DE15783 DE15912
        const getModalConfig = () => {
            if (wizardData.baseData?.productCode?.value === 'Homeowners') {
                return modalMessages.TWIAResidentialWizard;
            }

            if (buildingsAndLocationsStep?.id === 'BuildingsAndLocationsPage' && currentStepIndex === 2 && editMode) {
                return modalMessages.CancelModal;
            }
            return modalMessages.TWIAWizard;
        };

        const modalConfig = getModalConfig();
        //DE18500
        if (wizardData.baseData.policyAddress?.isNotValidated_Ext?.value) {
            StandardAddressValidationUtil.setOverridden(wizardData.baseData.policyAddress?.value);
        }

        if (wizardData.baseData.accountHolder?.primaryAddress?.isNotValidated_Ext?.value) {
            StandardAddressValidationUtil.setOverridden(wizardData.baseData.accountHolder?.primaryAddress?.value);
        }


       if (!(_.get(wizardData, 'aspects.subtreeValid') && _.get(wizardData, 'aspects.valid')) ||
       !(_.get(wizardContext, 'aspects.subtreeValid') && _.get(wizardContext, 'aspects.valid'))) {
            const result = await showConfirm(modalConfig);

            if (result === 'confirm') {
                if (wizardData.baseData?.productCode?.value !== 'Homeowners') {
                    const selectedLocation = wizardData.selectedLocation?.value;
                    const { selectedBuilding } = wizardData;

                    if (selectedLocation && !steps[2].submitted && steps[2].visited) {
                        if (
                            ((selectedLocation.buildings.length > 0) && selectedBuilding)
                        ) {
                            BuildingLocationUtil.removeCPBuilding(wizardData, wizardData.setSelectedBuildingIndex, authHeader)
                        } else if (selectedLocation.isNew) {
                            BuildingLocationUtil.removeLocation(wizardData.selectedLocation, wizardData, authHeader, wizardData.setSelectedLocation)
                        }
                    }
                }
                
                //DE18520
                if (/^\/coverage[\W_]?summary$|^\/payment[\W_]?details$/.test(steps[currentStepIndex]?.path)) {
                    if(!_.get(wizardData, 'baseData.accountHolder.emailAddress1NotProducerEmail_TWIA.value')) {
                        _.set(wizardData, 'baseData.accountHolder.emailAddress1.value', _.get(wizardSnapshot, 'baseData.accountHolder.emailAddress1.value'));
                    }
                    if(!_.get(wizardData, 'bindData.contactEmailNotProducerEmail_TWIA.value')) {
                        _.set(wizardData, 'bindData.contactEmail.value', _.get(wizardSnapshot, 'bindData.contactEmail.value'));
                    }
                }

                jumpTo(index)
            }
        } else {
            jumpTo(index)
        }
    }


}

function renderSteps(
    translator,
    steps,
    currentStepIndex,
    stepsWithErrors,
    jumpTo,
    wizardContext,
    authHeader,
    isFnolWizard
) {
    const shouldHideStep = wizardContext?.wizardData?.value?.baseData?.periodStatus === 'Submitted_Ext';
    const updatedSteps = shouldHideStep ? steps.filter(step => step.id === 'PaymentDetailsPage' || step.id === 'PaymentDetails') : steps
    return updatedSteps.map((step, index) => {
        const liClassName = classNames(styles.step, {
            [styles.active]: index === currentStepIndex,
            [styles.notVisited]: currentStepIndex < index,
        });

        return (
            <li className={liClassName} key={step.id}>
                <button
                    className={styles.navigationButton}
                    onClick={() => currentStepIndex > index &&
                        jumpRenderModal(
                            index,
                            wizardContext,
                            updatedSteps,
                            authHeader,
                            currentStepIndex,
                            isFnolWizard
                        )
                    }
                    type="button"
                >
                    {translator(step.title)}
                    {renderErrors(stepsWithErrors[step.id])}
                </button>
            </li>
        );
    });
}

function renderMobileSteps(translator,
    steps,
    currentStepIndex,
    stepsWithErrors,
    jumpTo,
    wizardContext,
    authHeader,
    isFnolWizard) {
    const shouldHideStep = wizardContext?.wizardData?.value?.baseData?.periodStatus === 'Submitted_Ext';
    const updatedSteps = shouldHideStep ? steps.filter(step => step.id === 'PaymentDetailsPage' || step.id === 'PaymentDetails') : steps
    return updatedSteps.map((step, index) => {
        const liClassName = classNames(styles.mobileStep, {
            [styles.active]: index === currentStepIndex,
            [styles.notVisited]: currentStepIndex < index,
        });

        return (
            <li className={liClassName} key={step.id} title={translator(step.title)}
                onClick={() => currentStepIndex > index &&
                    jumpRenderModal(
                        index,
                        wizardContext,
                        updatedSteps,
                        authHeader,
                        currentStepIndex,
                        isFnolWizard
                    )
                }
            />
        );
    });
}

function TWIAWizardSideMenu({ title }) {
    const wizardContext = useContext(WizardContext);
    const authHeader = _.get(useAuthentication(), 'authHeader');
    const translator = useTranslator();
    const breakpoint = useContext(BreakpointTrackerContext);
    const isPhone = breakpoint === 'phoneWide' || breakpoint === 'phone';
    const { steps, currentStepIndex, jumpTo, stepsWithErrors, wizardTitle, wizardData } =
        wizardContext;
    let sideBarTitle = title;
    const isFnolWizard = wizardData._dtoName.indexOf('fnol') !== -1;
    if (wizardData._dtoName.indexOf('fnol') !== -1) {
        sideBarTitle = wizardTitle;
    }
    return (
        <React.Fragment>
            {!isPhone &&
                <div className={styles.wizardSidebarWrapper}>
                    <h3 className={styles.sideBarTitle}>{translator(sideBarTitle)}</h3>
                    <div role="navigation" aria-label={translator(sideBarTitle)}>
                        <ul className={styles.stepsNav}>
                            {renderSteps(
                                translator,
                                steps,
                                currentStepIndex,
                                stepsWithErrors,
                                jumpTo,
                                wizardContext,
                                authHeader,
                                isFnolWizard
                            )}
                        </ul>
                    </div>
                </div>
            }
            {
                isPhone &&
                <ul className={styles.mobileNavStep}>
                    {renderMobileSteps(
                    translator,
                    steps,
                    currentStepIndex,
                    stepsWithErrors,
                    jumpTo,
                    wizardContext,
                    authHeader,
                    isFnolWizard
                    )}
                </ul>
            }
        </React.Fragment>
    );
}

export default TWIAWizardSideMenu;
